import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  BehaviorSubject,
  catchError,
  finalize,
  map,
  Observable,
  throwError,
} from 'rxjs';
import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { StateService } from '../services/common/claim-year.service';

@Injectable()
export class HTTPStatus {
  private requestInFlight$: BehaviorSubject<boolean>;
  constructor() {
    this.requestInFlight$ = new BehaviorSubject(false);
  }

  setHttpStatus(inFlight: boolean) {
    this.requestInFlight$.next(inFlight);
  }

  getHttpStatus(): Observable<boolean> {
    return this.requestInFlight$.asObservable();
  }
}

@Injectable()
export class HTTPListener implements HttpInterceptor {
  private isErrorShown = false;

  constructor(
    private readonly router: Router,
    private readonly status: HTTPStatus,
    private readonly toastr : ToastrService,
    private readonly spinner: NgxSpinnerService,
    private readonly companyService:StateService

  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let Spinner = document.getElementById('bootstrapSpinner');
    if (Spinner) {
      if (!req.url.includes('SavereferenceSKU')) {
        Spinner.style.display = 'block';
      }
    }
    
    const authReq = req.clone({
      headers: this.addExtraHeaders(req.headers),
    });
  
    return next.handle(authReq).pipe(
      map((event) => {
        return event;
      }),
      catchError((error) => {
        if (Spinner) {
          Spinner.style.display = 'none';
        }
        this.spinner.hide();
        
        // Handle error status
        if (error.status === 401 || error.status === 403) {
          if (!this.isErrorShown) {
            this.isErrorShown = true; // Set the flag to true to avoid duplicate messages
            if (error.status === 401) {
              this.toastr.error("Your session is expired. Please login again.");
            } else {
              this.toastr.error("Your session is expired. Please login again.");
            }
            localStorage.clear();
            this.companyService.clearAllData();
            this.router.navigate(['/login']);
          }
        }
        return throwError(() => {
          if (!this.isErrorShown) {
            this.toastr.error("Your session is expired. Please login again.");
          }
          localStorage.clear(); 
          this.companyService.clearAllData(); 
          this.router.navigate(['/login']);
          return error;
        });
      }),
      finalize(() => {
        if (Spinner) {
          Spinner.style.display = 'none';
        }
        this.status.setHttpStatus(false);
        
        // Reset the error flag when the API call completes
        setTimeout(() => {
          this.isErrorShown = false;
        }, 3000); // Optionally use a timeout to allow the user to see the error message
      })
    );
  }

  private addExtraHeaders(headers: HttpHeaders): HttpHeaders {
    const loginData = localStorage.getItem('JWTToken')
    if (loginData) {
      headers = headers.append('Authorization', 'Bearer ' + loginData);
    }
    return headers;
  }
}
